import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-shopping-cart-button-header',
  templateUrl: './shopping-cart-button-header.component.html',
  styleUrls: ['./shopping-cart-button-header.component.scss'],
})
export class ShoppingCartButtonHeaderComponent implements OnInit {
  @Input() totalPieces = 0;
  @Input() isScreenPhone = false;
  constructor() { }

  ngOnInit(): void { }
}
